import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const withAuthHeaders = (accessToken, userID) => ({
  "Content-Type": "application/json",
  authorization: accessToken,
  ...(userID ? { user: userID } : {}),
});

